const IdHashingStorage = require('./idHashingStorage');
const { hashSHA256 } = require('../../utils/crypto');
const Utils = require('./utils');

const getHashedIdAndUpdateCache = async (idType, payload, suppressCallback) => {
    const idValue = Utils.getIdFromAnalytics(idType);

    if (!idValue) {
        return {
            cacheUpdated: false,
            hashedId: undefined
        };
    }

    const storageId = IdHashingStorage.get(idValue);

    // hashSHA256 is async (native crypto.subtle.digest). The cache hit on
    // storageId still resolves synchronously via Promise.resolve semantics
    // when awaited, so repeat events with a known userId have no real cost.
    const hashedId = storageId || (await hashSHA256(idValue));

    if (!storageId) {
        const callbackData = {
            idType,
            suppressCallback,
            integrations: payload.integrations()
        };
        IdHashingStorage.set(idValue, hashedId, callbackData);
        return {
            cacheUpdated: true,
            hashedId: hashedId
        };
    }
    return {
        cacheUpdated: false,
        hashedId: hashedId
    };
};

module.exports = {
    getHashedIdAndUpdateCache
};
